/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:33 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("content-templates/content-edit/system/editorSystemWrapper.tmpl");
    var InputField = require("ui/input-field/InputField");
    var TextareaField = require("ui/textarea-field/TextareaField");
    var Button = require("ui/button/Button");
    var Dropdown = require("ui/dropdown/Dropdown");
    var DropdownMenu = require('ui/dropdown-menu/DropdownMenu');
    var ValidationUtilities = require("utils/ValidationUtilities");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var LanguageTabsView = require("content-views/content-edit/LanguageTabsView");
    var ContentSystemMessagingModel = require("content-models/system-messaging/ContentSystemMessagingModel");
    var systemMessageConfig = require("content-config/systemMessageConfig.json");
    var Constant = require("content-config/constant.json");

    //todo add real wysywig editor
    var TYPES = Constant.CONTENT_TYPES;

    var EditorSystemWrapperView = {};
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        EditorSystemWrapperView = Marionette.ItemView.extend({
            template: template,
            ui: {
                editorContainer: ".editor-container",
                activeButton:     ".active-button",
                activeLabel: ".active-label",
                tabsBarContainer:    ".language-tabs-container",
                selectAddMacroDropdownContainer: ".add-macro-dropdown-container",
                nameNoTimerWrapper:    ".name-no-timer-wrapper .event-name-container",
                timerFieldContainer: ".timer-field-container",
                deleteButton: ".buttons-container .button-delete",
                restoreToDefaultButton: ".buttons-container .button-restore-to-default",
                saveButton: ".buttons-container .button-save",
                timerFieldUnit: ".timer-field-unit",
                timerFieldUnitMessaging: ".timer-field-unit-messaging"
            },
            uiComponents: {
                activeButton: {
                    type: ToggleButton,
                    options: {
                        transition: ToggleButton.TRANSITION.FAST,
                        container: "view.ui.activeButton",
                        checked: "view._getContentEnabledState",
                        enabled: "view._getContentAllowEnabledState",
                        tooltip: "view.activeTooltipTexts"
                    },
                    events: {
                        "toggleButton:change": "_onActivate"
                    }
                },
                tabsView: {
                    type: LanguageTabsView,
                    options: {
                        el: "view.ui.tabsBarContainer",
                        model: "view._getModel",
                        channel: "view._getChannel",
                        reqres: "view._getReqres",
                        isMessaging: "view._isMessaging"
                    }
                },
                editorField: {
                    type: TextareaField,
                    options:{         // Component initialization options
                        permutation:TextareaField.PERMUTATION.F,
                        el:"view.ui.editorContainer",            // Using the ui definitions on the view requires the "view." prefix
                        value: "" ,
                        maxChars: "view._getMessagesMaxSize",
                        placeholder:  LE.translator.translate("LEContent.content.edit.languageBar.placeholder")
                    },
                    events:{                                        // Events that should be dispatched and propagated from the component to the parent view
                        change:"_editorTextChange"
                    }
                },
                addMacroDropdown: {
                    type:DropdownMenu,
                    options:{
                        name:LE.translator.translate("LEContent.content.macros.placeholder"),
                        el:"view.ui.selectAddMacroDropdownContainer",
                        collection: new DropdownMenu.Collection([])
                    },
                    events:{
                        "change":"_onMacroSelection"
                    }
                },
                timerField: {
                    type: InputField, // Component type to be instantiated
                    options: {         // Component initialization options
                        permutation: InputField.Permutation.J2,
                        el: "view.ui.timerFieldContainer",            // Using the ui definitions on the view requires the "view." prefix
                        "inputType": InputField.prototype.InputTypeEnum.PositiveNumber,
                        maxLength: 3
                    },
                    events: {                                        // Events that should be dispatched and propagated from the component to the parent view
                        change: "_timerValueChange"
                    }
                },
                deleteBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.deleteButton",
                        permutation: Button.PERMUTATION.LINK,
                        tooltip: LE.translator.translate("LEContent.content.edit.delete.tooltip"),
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT
                    },
                    events: {
                        "click": "_delete"
                    }
                },
                restoreToDefaultBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.restoreToDefaultButton",
                        permutation: Button.PERMUTATION.LINK,
                        tooltip: LE.translator.translate("LEContent.content.edit.restore.default.tooltip"),
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT
                    },
                    events: {
                        "click": "_restoreToDefault"
                    }
                },
                saveBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        initState:"view._getSaveButtonState",
                        tooltip:  "view._getSaveButtonTooltip",
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT
                    },
                    events: {
                        "click": "_save"
                    }
                }
            },
            validationSettings: {
                editorField: {
                    uiKey: "editorField",
                    errKeys: [""],
                    uiType: "uiComponents"
                },
                timerField: {
                    uiKey: "timerField",
                    errKeys: [""],
                    uiType: "uiComponents"
                }
            },
            activeTooltipTexts: {
                active:   LE.translator.translate("LEContent.content.edit.activation.button.tooltip.enabled"),
                inactive: LE.translator.translate("LEContent.content.edit.activation.button.tooltip.disabled"),
                tooltipAlign: ToggleButton.TOOLTIP_ALIGN.LEFT
            },

            initialize: function (options) {
                LEContent.logger.debug("Initializing EditorSystemWrapperView","EditorSystemWrapperView:initialize");
                this.channel = options.channel;
                this.reqres = options.reqres;
                this.contentModel = options.model.getContentModel();

                this.listenTo(this.model,"change:save.allowed",this._toggleSaveBtn);
                this.listenTo(this.model,"change:save.tooltipValue",this._toggleSaveBtnTooltip);
                this.listenTo(this.model.getLanguageTabCollection(),"change:selection",this._updateViewWithSelectedLanguageContent);
                this.listenTo(this.model,"change:model",this._updateViewWithChangedModel);
            },
            onRender: function () {
                LEContent.logger.debug("onRender EditorSystemWrapperView","EditorSystemWrapperView:onRender") ;
                this.uiComponents.editorField.showPlaceholder();
                this._updateViewWithChangedModel();
            },
            updateButtonsState: function (isDeleteButtonEnabled) {
                LEContent.logger.debug("updateButtonsState EditorSystemWrapperView","EditorSystemWrapperView:updateButtonsState") ;
                this.ui.deleteButton.toggleClass("hide", !isDeleteButtonEnabled);
                this.ui.restoreToDefaultButton.toggleClass("hide", isDeleteButtonEnabled);
            },
            _setValidationSettings : function() {
                this.validationSettings.editorField.errKeys = [this.model.getContentMSGKey()];
                if (this.model.isOnHoldSystemMessage()) {
                    //todo if there is more then timer create this autoamtically for all array attributes
                    //do it on validation utilities
                    this.validationSettings.timerField.errKeys = [this.contentModel.getTimerKey()];
                }
            },
            _renderTimerControl: function(){
                var isSystemMessagingType = this.model.getType() === TYPES.SYSTEM_MESSAGING;
                this.ui.timerFieldUnit.toggleClass("hide", isSystemMessagingType);
                if (isSystemMessagingType) {
                    if (!_.has(this.uiComponents, "timerUnits")){
                        this.uiComponents.host$.createAndRender("timerUnits", {
                            type: Dropdown,
                            options: {
                                container: "view.ui.timerFieldUnitMessaging",
                                items: "view._getTimerUnitsItems",
                                permutation: Dropdown.PERMUTATION.XX_SMALL2,
                                selectedOption: "view._getSelectedTimerUnit"
                            },
                            events: {
                                change: "_onTimerUnitChange"

                            }
                        });
                    }else{
                        //ui componenet already exists so only update the selection
                        this.uiComponents.timerUnits.setSelection(this._getSelectedTimerUnit(),{silent: true });
                    }

                    this.ui.timerFieldUnitMessaging.toggleClass("hide", false);
                }
            },
            _getTimerUnitsItems: function(){
                var items = [];

                _.each(ContentSystemMessagingModel.TIMER_UNITS, function (unit) {
                    items.push({
                        "key": unit,
                        "value": LE.translator.translate("LEContent.content.edit.system.timer.unit." + unit)
                    });
                });
                return new Dropdown.Collection(items);
            },
            _getSelectedTimerUnit: function(){
                return this.contentModel.getTimerUnit();
            },
            _onTimerUnitChange: function(componentId, eventName, unit){
                this.contentModel.setTimerUnit(unit.selectedKey);
            },
            _updateViewWithSelectedLanguageContent: function(){
                if (this.editorsLanguage !== this.model.getSelectedLanguage()) { //do not clear errors when its the same language content already seen
                    this.editorsLanguage = this.model.getSelectedLanguage();
                    this._clearErrors();
                }

                this._setValidationSettings();

                if (this._newLine2Br(this.uiComponents.editorField.getValue()) !== this.model.getSelectedLanguageContentMessage() && this.uiComponents.editorField.getValue() !== this.model.getSelectedLanguageContentMessage()) {
                    this.uiComponents.editorField.setValue(this._br2newLine(this.model.getSelectedLanguageContentMessage()));
                }
            },
            _updateViewWithSelectedAttributes: function(){
                if (this.model.isOnHoldSystemMessage()) {
                    this.uiComponents.timerField.setValue(this.model.getSystemMessageTimer());
                    this._renderTimerControl();
                }
            },
            _updateViewWithChangedModel: function () {
                this._hideErrors();
                this.stopListening(this.contentModel);
                this.contentModel = this.model.getContentModel();
                this.listenTo(this.contentModel,"invalid",this._invalid);
                this.listenTo(this.contentModel,"change:data",this._updateViewWithSelectedLanguageContent);
                this.listenTo(this.contentModel,"change:attributes",this._updateViewWithSelectedAttributes);

                this.uiComponents.activeButton.setChecked(this.model.getEnabledState());
                this.uiComponents.activeButton.setEnabled(this.model.isEnabledEditable());

                if(this.model.isEnabledEditable()){
                    this.ui.activeButton.removeClass("hide");
                    this.ui.activeLabel.removeClass("hide");
                }
                else{
                    this.ui.activeButton.addClass("hide");
                    this.ui.activeLabel.addClass("hide");
                }

                this._updateViewWithSelectedAttributes();

                this._clearErrors();
                this._updateViewWithSelectedLanguageContent();
                this._updateMacroDropdownOptions();
            },
            _onActivate: function (componentId, eventName, value) {
                this.channel.trigger("editorSystemWrapperView:toggle:activate:change",value);
            },
            _updateMacroDropdownOptions: function(){
                var allowedMacros = this.model.getAllowedMacros();

                if(allowedMacros.length === 0){
                    this.uiComponents.addMacroDropdown.setEnabled(false);
                    this.ui.selectAddMacroDropdownContainer.addClass("hide");
                }
                else{
                    var items = _.map(allowedMacros,function(macro){
                        return {
                            id: macro.value,
                            "actionName": LE.translator.translate("LEContent.content.macros." + macro.id),
                            "enabled": true,
                            "title": LE.translator.translate("LEContent.content.macros." + macro.id +".tooltip")
                        };
                    },this);

                    this.uiComponents.addMacroDropdown.setEnabled(true);
                    this.ui.selectAddMacroDropdownContainer.removeClass("hide");
                    this.uiComponents.addMacroDropdown.setItems(new DropdownMenu.Collection(items));
                }
            },
            _onMacroSelection: function (componentId, eventName, id){
                this.uiComponents.editorField.setValueAtCourser(this._br2newLine(id));
            },

            _editorTextChange: function (componentId, eventName, value) {
                var text = this._isMessaging() ? value.trim() : this._newLine2Br(value.trim());
                this.channel.trigger("editorSystemWrapperView:editor:text:change",text);
            },
            _newLine2Br: function (text){
                return text.replace(/\r\n|\r|\n/g,"<br/>");
            },
            _br2newLine: function (text){
                return text.replace(/<br\/>/g,"\r\n");
            },
            _invalid: function(model, errors) {
                LEContent.logger.info("on Invalid called", "EditSystemTextView:onInvalid");
                ValidationUtilities.setValidationErrors(this,false,this.contentModel);
            },
            _clearErrors: function(){
                this.uiComponents.editorField.setError(false);
            },
            _delete: function () {
                LEContent.logger.info("User clicked on 'Delete' button.", "EditorSystemWrapperView::_delete");
                this.channel.trigger("editorSystemWrapperView:delete");
            },
            _restoreToDefault: function () {
                LEContent.logger.info("User clicked on 'RestoreToDefaults' button.", "EditorSystemWrapperView::_restoreToDefaults");
                this.channel.trigger("contentSystemEditLayout:actions:restoreToDefaults");
            },
            _save: function () {
                LEContent.logger.info("User clicked on 'Save' button.", "EditorSystemWrapperView::_save");
                this.channel.trigger("editorSystemWrapperView:save");
            },
            _isMessaging: function () {
                return this.model.getType() === TYPES.SYSTEM_MESSAGING;
            },

            //---------------------------------------------------
            // Toggle save button to enable / disable according to required values for save of system models
            //---------------------------------------------------
            _toggleSaveBtn:function () {
                this.uiComponents.saveBtn.setState(this._getSaveButtonState());
            },
            _toggleSaveBtnTooltip:function () {
                this.uiComponents.saveBtn.setTooltip(this._getSaveButtonTooltip());
            },
            _getSaveButtonState : function () {
                return this.model.getIsSaveAllowed() ? Button.STATES.ENABLED : Button.STATES.DISABLED;
            },
            _getSaveButtonTooltip : function () {
                var tooltipTranslatedText = this.model.getIsSaveAllowedTooltipValue();

                return tooltipTranslatedText;
            },
            _getModel: function () {
                return this.model;
            },
            _getChannel: function () {
                return this.channel;
            },
            _getReqres: function () {
                return this.reqres;
            },
            _getMessagesMaxSize: function() {
                return this._isMessaging() ? systemMessageConfig.maxMessageSize.messaging : systemMessageConfig.maxMessageSize.liveChat;
            },
            _timerValueChange: function(componentId, eventName, value){
                var timerValue = parseInt(value, 10);
                // check if parsing failed
                if (_.isNaN(timerValue)) {
                    // if value is not numeric - reset to "" - and update view
                    timerValue = "";
                }
                this.channel.trigger("editSystemTextView:timer:change",timerValue);
            },
            _hideErrors:function () {
                this.uiComponents.timerField.setError(false);
            },

            onClose: function () {
                LEContent.logger.debug("onClose EditorSystemWrapperView", "EditorSystemWrapperView:onClose");
            }
        });

    });
    return EditorSystemWrapperView;
});
